import { render, staticRenderFns } from "./RegisteredObjectsForm.vue?vue&type=template&id=7f050e37&scoped=true&"
import script from "./RegisteredObjectsForm.vue?vue&type=script&lang=js&"
export * from "./RegisteredObjectsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f050e37",
  null
  
)

export default component.exports